'use client'
const ONRAMP_PROVIDERS = ['banxa'];

export { ONRAMP_PROVIDERS };
